import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, TransitionGroup as _TransitionGroup, withCtx as _withCtx, withKeys as _withKeys } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "o-eventPromotion__spinner"
}
const _hoisted_3 = {
  key: 0,
  class: "o-eventPromotion__selectionContainer"
}
const _hoisted_4 = { class: "o-eventPromotion__promotionDropdown" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 3,
  class: "o-eventPromotion__pitch"
}
const _hoisted_7 = {
  key: 4,
  class: "o-eventPromotion__footer"
}
const _hoisted_8 = { class: "a-notice__error" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerComponent = _resolveComponent("SpinnerComponent")!
  const _component_SelectionComponent = _resolveComponent("SelectionComponent")!
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_TextInputComponent = _resolveComponent("TextInputComponent")!
  const _component_button_component = _resolveComponent("button-component")!
  const _directive_translate = _resolveDirective("translate")!

  return (_ctx.promotionStore.availablePromotions.length > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "event-promotion-panel",
        class: _normalizeClass([{
            '-no-border-top': !_ctx.isMobile,
            '-no-border-bottom': !_ctx.shouldDisplayBottomBorder() ,
            '-no-padding': !_ctx.panelState.isPromotionPanelActive() && !_ctx.promotionStore.active
         }, "o-eventPromotion"])
      }, [
        (_ctx.promotionStore.canDisplayHeader)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass([{ '-fullWidth': !_ctx.isMobile }, "o-eventPromotion__heading"])
            }, [
              (_ctx.activePromotion)
                ? _withDirectives((_openBlock(), _createElementBlock("h3", _hoisted_1, [
                    _createTextVNode("Promotion: " + _toDisplayString(_ctx.activePromotion.name), 1)
                  ])), [
                    [_directive_translate, {
                    key: _ctx.Translation.Promotion_selected_promotion_interface_title,
                    keyValues: JSON.stringify({ promotionName: _ctx.activePromotion.name })
                }]
                  ])
                : _createCommentVNode("", true)
            ], 2))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass([{ '-has-padding': !_ctx.isMobile && _ctx.activePromotion }, "o-eventPromotion__form -in-column"])
        }, [
          (_ctx.promotionStore.spinner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_component_SpinnerComponent)
              ]))
            : _createCommentVNode("", true),
          (_ctx.promotionStore.active !== null)
            ? (_openBlock(), _createBlock(_component_SelectionComponent, {
                key: 1,
                value: _ctx.activePromotionLabel,
                onRemove: _ctx.handleRemoval
              }, null, 8, ["value", "onRemove"]))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                (_ctx.panelState.isPromotionPanelActive())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createElementVNode("div", {
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.togglePromoSelection())),
                        class: _normalizeClass([{'-has-border' : _ctx.isPromoSelectionOpen}, "o-eventPromotion__promotionSelection"])
                      }, [
                        _createElementVNode("p", {
                          class: _normalizeClass([{ '-has-opacity': !_ctx.promotionStore.selection }, "o-eventPromotion__promotionName"])
                        }, _toDisplayString(_ctx.selectionText()), 3),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(_component_IconComponent, {
                            "icon-id": _ctx.IconName.Arrow,
                            class: _normalizeClass(_ctx.isPromoSelectionOpen ?
                                    'o-eventPromotion__collapseArrow'
                                    : 'o-eventPromotion__expandArrow')
                          }, null, 8, ["icon-id", "class"])
                        ])
                      ], 2),
                      _createVNode(_TransitionGroup, { name: "slide" }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.promotionStore.availablePromotions, (promotion, index) => {
                            return _withDirectives((_openBlock(), _createElementBlock("div", {
                              class: _normalizeClass([{ '-active': promotion.id === _ctx.promotionStore.selection?.id }, "o-eventPromotion__promotionSelection"]),
                              key: index,
                              onClick: ($event: any) => (_ctx.selectDropdownPromotion(promotion))
                            }, [
                              _createElementVNode("p", null, _toDisplayString(promotion.name), 1)
                            ], 10, _hoisted_5)), [
                              [_vShow, _ctx.isPromoSelectionOpen]
                            ])
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.selection && _ctx.panelState.isPromotionPanelActive())
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["enter"])),
                      class: _normalizeClass({ 'is-button-group' : !_ctx.selection.isCodeRequired })
                    }, [
                      (_ctx.selection.isCodeRequired)
                        ? (_openBlock(), _createBlock(_component_TextInputComponent, {
                            key: 0,
                            label: _ctx.inputPlaceholder,
                            name: 'promotion-code',
                            value: _ctx.inputValue,
                            hasSubmitAction: false,
                            "input-qa-selector": _ctx.PerformanceQASelectors.PROMOTION_CODE,
                            "action-qa-selector": _ctx.PerformanceQASelectors.PROMO_ARROW,
                            onInput: _ctx.handleInput
                          }, null, 8, ["label", "value", "input-qa-selector", "action-qa-selector", "onInput"]))
                        : _createCommentVNode("", true)
                    ], 34))
                  : _createCommentVNode("", true),
                (_ctx.panelState.isPromotionPanelActive())
                  ? (_openBlock(), _createBlock(_component_button_component, {
                      key: 2,
                      label: _ctx.applyButtonLabel,
                      active: _ctx.canSubmit,
                      onSubmit: _ctx.handleSubmit
                    }, null, 8, ["label", "active", "onSubmit"]))
                  : _createCommentVNode("", true)
              ], 64)),
          (!_ctx.activePromotion && _ctx.panelState.isPromotionPanelActive())
            ? _withDirectives((_openBlock(), _createElementBlock("p", _hoisted_6, [
                _createTextVNode("Select promotion and enter your promotion code.")
              ])), [
                [_directive_translate, { key : _ctx.Translation.Promotion_interface_subtitle }]
              ])
            : _createCommentVNode("", true),
          (_ctx.promotionStore.error && _ctx.panelState.isPromotionPanelActive())
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.promotionStore.error), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ], 2))
    : _createCommentVNode("", true)
}